import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-lg row justify-center" };
const _hoisted_2 = { class: "q-pa-md" };
const _hoisted_3 = { class: "table-caption" };
const _hoisted_4 = { class: "entry-check-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "full-width" }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, { class: "col-12 col-xl-10 col-lg-10 col-md-10" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "text-h4 text-bold text-green-7" }, "認証コード入力", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createTextVNode(" 【 " + _toDisplayString(_ctx.mailAddress) + " 】 宛に、メールを送信しました。", 1),
                                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                        _cache[4] || (_cache[4] = _createTextVNode(" メールに記載されている認証コードを入力してください。", -1)),
                                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.authLimit) + "分経過してもメールが届かない場合はメールアドレスを確認の上、", 1),
                                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                        _cache[8] || (_cache[8] = _createTextVNode(" 恐れ入りますが再度メールアドレスの入力からやり直してください。 ", -1))
                                    ]),
                                    _createElementVNode("table", _hoisted_4, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, [
                                                    _cache[10] || (_cache[10] = _createTextVNode("認証コード ", -1)),
                                                    _createVNode(_component_q_badge, {
                                                        color: "red-9",
                                                        align: "middle"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                                _createTextVNode("必須", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_input, {
                                                        modelValue: _ctx.data.authCode,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.authCode) = $event)),
                                                        color: "positive",
                                                        outlined: "",
                                                        "bottom-slots": "",
                                                        dense: "",
                                                        error: _ctx.valid.authCode.error,
                                                        "error-message": _ctx.valid.authCode.message
                                                    }, null, 8, ["modelValue", "error", "error-message"])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg row",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: "戻る",
                                    class: "btn-route col-5 col-md-3",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$router.back()))
                                }),
                                _createVNode(_component_q_btn, {
                                    label: "認証",
                                    class: "btn-route col-5 col-md-3",
                                    color: "green-7",
                                    "icon-right": "navigate_next",
                                    onClick: _ctx.submit
                                }, null, 8, ["onClick"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
